module.exports = __webpack_public_path__ + "media/src/assets/mobile_nav_logo-15ab19db51f9da6b1899880ab45b4adb.png";